/* NĒM global chrome: sticky header state and the mobile drawer.
   Ported from the WordPress build so the behaviour matches exactly. */
(function () {
  'use strict';

  var body = document.body;
  var header = document.getElementById('oxyInnerHeader');
  var toggle = document.getElementById('oxyhdMobileToggle');
  var closeButton = document.getElementById('oxyhdMobileClose');
  var overlay = document.getElementById('oxyhdMobileOverlay');
  var drawer = document.getElementById('oxyhdMobileDrawer');
  var shop = document.getElementById('oxyhdMobileShop');
  var shopTrigger = document.getElementById('oxyhdMobileShopTrigger');

  function updateHeaderScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 14);
  }

  function openMenu() {
    if (!toggle || !drawer) return;
    body.classList.add('oxyhd-menu-open');
    toggle.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () {
      if (closeButton) closeButton.focus();
    }, 120);
  }

  function closeMenu() {
    if (!toggle || !drawer) return;
    body.classList.remove('oxyhd-menu-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function toggleProducts() {
    if (!shop || !shopTrigger) return;
    var open = !shop.classList.contains('is-open');
    shop.classList.toggle('is-open', open);
    shopTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  updateHeaderScroll();
  window.addEventListener('scroll', updateHeaderScroll, { passive: true });

  if (toggle) toggle.addEventListener('click', openMenu);
  if (closeButton) closeButton.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  if (shopTrigger) shopTrigger.addEventListener('click', toggleProducts);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && body.classList.contains('oxyhd-menu-open')) {
      closeMenu();
      if (toggle) toggle.focus();
    }
  });

  if (drawer) {
    Array.prototype.forEach.call(drawer.querySelectorAll('a'), function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  window.addEventListener('resize', function () {
    if (window.innerWidth > 1024) closeMenu();
  });

  /* Reveal-on-scroll used across the ported sections. */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );
    Array.prototype.forEach.call(document.querySelectorAll('[data-oxy-reveal]'), function (el) {
      observer.observe(el);
    });
  } else {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oxy-reveal]'), function (el) {
      el.classList.add('is-visible');
    });
  }
})();
